export default {
  title: 'Заказать обратный звонок',
  description: 'Закажите обратный звонок совершенно бесплатно и мы свяжемся с Вами в кратчайшие сроки',
  inputPhone: 'Ваш номер телефона',
  cta: 'Заказать',
  notification: 'Спасибо за заявку! Мы скоро Вам перезвоним.',
};
